// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Centro dati",
        pull_refresh: "Tirare verso il basso per rinfrescare",
        release_refresh: "Rilascia per aggiornare",
        refresh_loading: "Caricamento…",
        footer_text: "Servizi forniti da Ucloudlink (NASDAQ: UCL)"
    },
    home: {
        input_placeholder: "Cerca paese/regione",
        my_flow: "I miei dati",
        charge_code: "Codice voucher",
        coupons:'Coupon',
        local_package: "Dati locali",
        more: "Di più",
        popular_destination: "Paese/regione",
        buy_now: "Acquista ora",
        package_useing: "Attivo",
        unused: 'Inattivo',
        download_app: "Scarica l'app",
        enter_the_mall_list: "Vai al centro commerciale",
        no_data: "Nessun dati ancora",
        no_data_available: 'Nessun dato disponibile',
        copy_success: "Copia riuscita",
        copy_fail: "Copia non riuscita",
        meritsTitle: 'Quali sono i vantaggi?',
        merits1: 'Senza SIM richiesto & Senza costo mensile',
        merits2: 'Integrato con i top 2-3 operatori per cambio automatico di rete',
        go_buy: "Acquistare",
        instant_savings: "Risparmia",
        expires_in: "Scade tra",
        download_app_tips: "Scarica l’app per più offerte ed esperienze"
    },
    packages: {
        sub_title: {
            us: "Esclusa Guam, Saipan",
            it: "Inclusa Città del Vaticano, San Marino",
            va: "Compresa l'Italia, San Marino",
            sm: "Compresa l'Italia, Città del Vaticano",
            ma: "Compreso il Sahara Occidentale",
            eh: "Marocco compreso",
            ch: "Liechtenstein compreso",
            li: "Svizzera compresa",
            fr: "Monaco compreso",
            mc: "Francia compresa",
            fi: "Comprese le Isole Aland",
            ax: "Finlandia compresa",
            gu: "Comprese le Isole Marianne Settentrionali",
            mp: "Guam compresa"
        },
        unlimited_packages: "Pacchetto dati illimitato",
        normal_packages: "Pacchetto dati normale",
        multi_region_packages: "Multiregione",
        regional_data: "Dati Regionali",
        high_speed_text: "dati ad alta velocità",
        infiniteFlow: 'Dati illimitati',
        unLimitData: 'Illimitato',
        high_speed_text_year: "alta velocità/mp",
        package_list: "Elenco dei pacchetti",
        special_offer: 'Saldi',
        first_month: '1° Mese',
        periodUnit: {
            day: "giorno/i",
            month: "mese",
            hour: "ore)",
            year: "anno"
        },
        periodUnits: {
            day: "giorno/i",
            month: "mesi",
            hour: "ore)",
            year: "anni"
        },
        periodUnitSimp: {
            day: "D",
            month: "per",
            hour: "H",
            year: "IL"
        },
        periodUnitMonthly:'Mensile',
        periodUnitsSimp: {
            day: "D",
            month: "per",
            hour: "H",
            year: "IL"
        },
        unlimited_good_name: {
            day: "Biglietto giornaliero",
            month: "Abbonamento mensile",
            year: "Abbonamento annuale"
        },
        continuousMonth: "Mesi continui",
        continuousDay: "Giorni continui",
        continuousYear: "Anni continui",
        day_invalid: "Scade il giorno corrente",
        month_invalid: "Scade nel mese corrente",
        immediate_valid: "Con effetto immediato",
        tomorrow_day_valid: "In vigore dal giorno successivo",
        tomorrow_month_valid: "In vigore dal mese prossimo",
        detail: {
            cell_flow: "Dati",
            cell_period: "Validità",
            buy_quantity: "Quantità",
            use_area: "Copertura",
            use_intro: "Termini e Condizioni",
            buy_btn: "Ordine",
            pay: "Paga",
            buy_tips: 'Hai il pacchetto %@packageName in uso. Vuoi acquistare questo pacchetto?',
            haveOrderTips: "Ordine in attesa di pagamento generato. Clicca Conferma per accedere alla mia pagina dati！"
        },
        confirm: {
            title: "Conferma dell'ordine",
            real_pay_amount: "Importo pagato",
            online_payment: "Pagamento in linea",
            create_order_error: "L'installazione non è riuscita"
        }
    },
    pay: {
        result: {
            loading_order_status: "Ottenere lo stato dell'ordine…",
            buy_success: "Ordine completato",
            buy_pending: "In attesa di conferma",
            buy_pending_tip: "Pagamento in corso…Se il pagamento non viene trasferito entro 10 minuti, contattaci per ricevere assistenza.",
            get_payment_info_fail: "Acquisizione delle informazioni di pagamento non riuscita",
            cell_package: "Pacchetto",
            cell_buy_amount: "Totale parziale",
            cell_real_amount: "Importo pagato",
            go_to_order_btn: "Vai a Il mio pacchetto",
            back_home: "Ritorno a casa",
            back_mall: "Torna al centro commerciale",
            ordersn_empty: "Il SN dell'ordine non può essere vuoto",
            order_search_error: "Errore imprevisto",
            goodsName:"Nome prodotto"
        },
        fail: {
            payment_fail: "Pagamento non riuscito",
            back_home: "Ritorno a casa"
        }
    },
    CountryGroup: {
        title: "Paese/regione",
        placeholder: "Cerca paese o regione",
        clear: "Chiaro",
        history: "Cronologia delle ricerche"
    },
    PromotionCode: {
        verification: {
            title: "Codice voucher",
            minititle: "Codice voucher",
            input: "Inserisci il codice di ricarica",
            explain: "Suggerimenti: tocca il pulsante di scansione in alto a destra per scansionare il codice QR della carta voucher o inserisci manualmente il codice voucher (con distinzione tra maiuscole e minuscole) se non funziona.",
            submit: "Invia",
            exchange: "Riscattare",
            cancel: "Cancellare",
            Inquiry: "Sei sicuro di scambiare?",
            ErrorCode: "Errore codice ricarica"
        },
        recharge_success: {
            package: "Pacchetto",
            content: "Redento con successo",
            back: "Torniamo al centro commerciale",
            view_packets: "Vai a Il mio pacchetto"
        }
    },
    order: {
        state: {
            inUse: "Attivato",
            isFirst: "Priorizzato",
            toFirst: "Imposta la priorità",
            inactive: "Inattivato"
        },
        periodUnits: {
            minute: "minuto/i",
            hour: "ore)",
            day: "giorno/i",
            month: "mesi)"
        },
        useIntro: {
            tip1: "Il pacchetto dati illimitato ha una priorità più alta rispetto al pacchetto dati volume；",
            tip2: "La priorità di utilizzo sarà basata sulla data di acquisto per lo stesso tipo di pacchetto, ovvero il pacchetto con la prima data di acquisto verrà utilizzato per primo, mentre la priorità dei pacchetti a regione singola è superiore rispetto al pacchetto regionale；",
            tip3: "Puoi anche regolare manualmente la priorità di utilizzo dei pacchetti dello stesso tipo。"
        },
        myFlow: "I miei dati",
        remainingFlow: "Dati rimasti",
        remainingTime: "Sinistra valida",
        remainingHighFlow: "Sono rimasti dati ad alta velocità",
        validPeriod: "Validità",
        noneFlow: "Nessun pacchetto dati",
        noneFlowTip: "Acquista il pacchetto dati e goditi la rete di alta qualità",
        buyPackFlow: "Acquistare pacchetti",
        checkInvalidFlow: "Controlla il pacchetto dati scaduto",
        orderList: {
            "title": "i miei ordini",
            "amount_paid": "Totale",
            "device": "Dispositivo di proprietà",
            "order_details": "Dettagli dell'ordine",
            "total_amont": "Totale parziale",
            "orderSN": "Ordine n.",
            "createTime": "Tempo di creazione",
            "cancelTime": "Orario chiuso",
            "payTime": "Orario dell'ordine",
            "unsubTime": "Orario annullato",
            "payMethod": "Metodo di pagamento",
            "thirdSN": "Transazione n.",
            "delete": "Eliminare",
            "cancel": "Annulla ordine",
            "unsub": "Rimborso",
            "goto_cancel": "Vuoi annullare l'ordine?",
            "goto_unsubscribe": "Vuoi annullare l'iscrizione all'ordine?",
            "delete_Tips": "L'ordine non può essere ripreso dopo essere stato eliminato, pertanto i problemi post-servizio non possono essere gestiti.Sei sicuro di volerlo eliminare?",
            "status_success": "Completato",
            "status_pending": "Non pagato",
            "status_cancel": "Chiuso",
            "status_unsub": "Annullato",
            "payMethod_stripe": "Carta di credito"
          },
    },
    registerlogin: { 
        create_account_tip:"Crea un account, inizia un'esperienza esclusiva",
        select_country_tip:"Dispositivo Utilizzare il paese/regione",
        email_name: "Posta",
        phone_name: "Telefono",
        email_address: "Indirizzo e-mail",
        password: "password",
        country: "Paese",
        select_country: "Scegli un paese",
        cancel: "Cancellare",
        confirm: "Sicuro",
        please_enter: "Inserisci 6-20 caratteri (combinazione di lettere, numeri o simboli)",
        select_country_tips: "La selezione del paese è per la visualizzazione di pacchetti locali. Non può essere modificato dopo la registrazione. Per favore conferma!",
        global_roaming: "Codice di dominio internazionale",
        phone_number: "Numero di telefono",
        agree: "Essere d'accordo",
        user_agreement: "Accordo utente",
        and: "E",
        privacy_policy: "politica sulla riservatezza",
        register_login: "Iscriviti o accedi",
        login_error: "Il numero di accessi è troppo frequente, riprova più tardi!",
        register_error: "Il numero di registrazioni è troppo frequente, riprova più tardi!",
        forgot_pwd: "Dimentica la password",
        app_tips: "Accedi all'app con questo account dopo averlo scaricato per accedere a più funzionalità.",
        download_app: "Vai a scaricare l'app",
        rememberPwd: "Ricorda la password",
        third_login: 'Continua con',
        agreement_tips: "Seleziona la casella Condizioni d'uso e Informativa sulla privacy",
        selectCountry_tips: "Tieni presente che il Paese registrato influirà direttamente sui seguenti metodi di pagamento e valute, selezionalo in base alle tue necessità.",
        login_error_cancel: "L'utente ha annullato l'accesso",
        login_error_auth: "Abilita i pop-up dalle impostazioni del browser",
        device_tips: "Dispositivo in attesa di attivazione. Elaborazione in 24h."
      },
      forgotPwd: {
        forgot_pwd: "Dimentica la password",
        email_address: "Indirizzo e-mail",
        next: "Prossimo",
        email_has_been_sent: "Abbiamo inviato un'e-mail a %@email. Fare clic sul collegamento e seguire i passaggi per recuperare la password.",
        have_retrieved_it: "L'ho trovato",
        unable_to_receive_email: "Non puoi ricevere l'email? Si prega di controllare se ci sono e-mail da %@email sotto la tua spam e directory di posta eliminata",
        or: "O",
        resend: "RECEND",
        global_roaming: "Codice di dominio internazionale",
        phone_number: "Numero di telefono",
        verification_code_has_been_sent: "Abbiamo inviato il codice di verifica a:",
        verification_code: "Codice di verifica",
        no_verification_code_received: "Non hai ricevuto il codice di verifica?",
        please_enter: "Inserisci 6-20 caratteri (combinazione di lettere, numeri o simboli)",
        reset_password: "Reimpostare la password",
        reset_successful: "Ripristina correttamente"
      },
    coupons: {
        coupons_name: "Coupon",
        no_coupons: "Nessun coupon ancora",
        no_data: "Nessun dati ancora",
        applicable_to_the_following: "I coupon sono adatti per il seguente pacchetto di dati"
    },
    digital: {
        title: "Dispositivo Sn",
        purchased: "I miei acquisti",
        viewAll: "Di più",
        skinStore: "Negozio di prodotti",
        completed: "Acquistato",
        goBuy: "Acquistare",
        order: {
            title: "Ordini acquistati"
        },
        detail: {
            describe: "Descrizione"
        }
    },
    viewPL: {
        other: 'altri'
      },
    invalidFlow: {
        stateName: "Stato",
        state: {
            NOT_ACTIVATED: "Inattivato",
            IN_USING: "Disponibile",
            USE_END: "Esausto",
            EXPIRE: "Scaduto",
            TRANSFER: "Trasferire",
            UNSUBSCRIBE: "Cancellare",
            VALID: "Valido",
            INVALID: "Non valido",
            EXCHANGE_POINTS: "Riscatta punti"
        },
        noneFlow: "Nessun pacchetto dati scaduto",
        pageName: "Pacchetto dati scaduto"
    },
    flowDetail: {
        title: "Dettagli dei dati",
        flow: "Dati",
        validTime: "Dettagli dei dati",
        invalidTime: "Valido fino al",
        coverage: "Copertura",
        useIntro: "Termini e Condizioni",
        purchaseTime: "Acquistato presso",
        subtotal: "Totale parziale",
        status: "Stato",
        cancel: "Cancellare",
        buyAgain: "Compralo di nuovo",
        validity: "Validità",
        tip: "Avviso",
        cancelTip: "Sei sicuro di voler rimborsare questo pacchetto?",
        dataLeft: "Dati rimasti"
    },
    netError: {
        try_again: "Riprova",
        net_error: "Nessuna rete",
        try_again_desc: "Controlla le impostazioni di rete e riprova"
    },
    loadFail: {
        try_again: "Riprova",
        load_fail: "Caricamento non riuscito",
        load_fail_desc: "Caricamento dati non riuscito, riprova",
        IMEI_Not_Exist: "L'IMEI non esiste, prova ad entrare dall'ingresso destro",
        Project_Not_Exist: "Si verifica un errore. Si prega di contattare il servizio clienti.(01)",
        commonError: "Si verifica un errore. Si prega di contattare il servizio clienti."
    },
    settlement_Easy_and_convenient: "Facile e conveniente",
    settlement_Great_deal: "Grande affare",
    settlement_Safe_and_secure: "Sicuro e sicuro",
    settlement_Autopay_service_regulation: "Regolamento sul servizio automatico",
    settlement_Read: "Leggere",
    settlement_No_coupon: "Nessun coupon disponibile",
    settlement_Subtotal: "Subtotale",
    settlement_Coupon: "Coupon",
    settlement_TOTAL: "Totale",
    settlement_promotion_tip: "L'offerta promozionale non può essere utilizzata insieme a coupon",
    settlement_coupon_tip: "Il coupon non può essere utilizzato insieme a qualsiasi altra offerta promozionale",
    member_myFlow_noList: "Nessun dato",
    detail_se_content: "Un modo sicuro, facile e conveniente. Puoi annullare l'iscrizione in qualsiasi momento",
    Enter_Promo_code: "Codice di promozione",
    Enter_Promo_Coupon:"Coupon",
    settlement_Not_used_coupon:"coupon non usato",
    settlement_Available_coupon:"Disponibile",
    settlement_Unavailable_coupon:"Non disponibile",
    please_Enter_Promo_code: "Inserisci il codice di promozione",
    please_Select_Coupon_use:　"Seleziona il coupon che desideri utilizzare.",
    Buy_Now: "Acquista ora",
    Dont_Use_Any: "Non usarne nessuno",
    settlement_confirm: "Confermare",
    flowDetail_unsubscribe: "Annullare l'iscrizione",
    flowDetail_unsubscribed: "Non sottoscritto",
    flowDetail_isCancelPackage: "Annullare l'iscrizione a questo pacchetto?",
    flowDetail_confirmAgreementUnsubscribe: "Non puoi avere il grande affare dopo l'iscrizione. Sei sicuro di voler annullare l'iscrizione?",
    flowDetail_cancel: "Cancellare",
    flowDetail_cancelSuccess: "Annullare l'iscrizione con successo",
    packages_detail_promotion: "Promozione",
    orderTips:{
        "iDay" : "giorno",
        "iDays" : "giorni",
        "iMonth" : "mese",
        "iMonths" : "mesi",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Al tuo primo acquisto, Paga %@money/%@periodSymbol più tardi, Puoi annullare l'iscrizione in qualsiasi momento",
        'Monthly_discount':"Risparmia %@saveMoney ciascuno %@period! Puoi annullare l'iscrizione in qualsiasi momento ",
        'Ordinary_monthly_package':"Un modo sicuro, facile e conveniente. Puoi annullare l'iscrizione in qualsiasi momento",
        "AlreadyPurchased":"Mi dispiace che tu possa iscriverti a un solo pacchetto di dati al momento. Si prega di annullare l'iscrizione a “%@” e iscriviti più tardi a qualsiasi pacchetto desiderato dopo la scadenza.",
        "Contract_recommendation_First":'<label>Con il servizio Autopay, al tuo primo acquisto, paga solo</label>'
        +'<p class="money">%@firstMoney</p>'
        +"<p class='SubscribeTips'>Puoi annullare l'iscrizione in qualsiasi momento"
        +'<a class="btn">Iscriviti ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Con il servizio automatico, paga solo</label>"
        +'<p class="money">%@money</p>'
        +"<p class='SubscribeTips'>Puoi annullare l'iscrizione in qualsiasi momento"
        +'<a class="btn">Iscriviti ></a></p>',
        "Contract_recommendation_General":"<label>Con servizio automatico</label>"
        +'<p class="money">%@money</p>'
        +"<p class='SubscribeTips'>Un modo sicuro, facile e conveniente. Puoi annullare l'iscrizione in qualsiasi momento"
        +'<a href="javascript:;" class="btn">Iscriviti ></a></p>',
        'BanlanceDoubleCheck':'Sei sicuro di voler pagare con il saldo?',
    },
    feedback: {
        title: "feedback",
        placeholder: "Inserisci il paese che desideri visitare o qualsiasi altra domanda e soddisferemo le tue esigenze il prima possibile!",
        submit: "Invia",
        submit_success: "Invio riuscito",
        other_opinions: "Altre opinioni"
    },
    view_country_input: 'Inserisci il tuo account',
    select_package: {
        title: "Selezionare i Dati",
        allPackage: 'Tutti i Dati',
        type: "Tipo",
        flow: "Dati",
        month_package: "Piano Mensile",
        flow_package: "Pacchetto Dati",
        time: "Durata",
        period: "Ciclo",
        auto_debit: "Info Addebito Automatico",
        auto_subscribe: "Auto-Rinnovo",
        detail: "Dettagli dei Dati",
        carrier: "Operatori Supportati",
        country: "Paesi Coperti",
        notice: "Guida all'Acquisto"
      }
}